import { Layout } from 'src/components/layout/layout';

const Coupons = () => {
    return <Layout>Coupons</Layout>;
};

export default Coupons;
